import { formatRelativeThai } from '@natashu/shared';
import { useSyncExternalStore } from 'react';
import { formatThaiFullDateTime } from '../../lib/format.ts';

const TICK_MS = 30_000;
let now = Date.now();
let timer: number | undefined;
const subscribers = new Set<() => void>();

function subscribe(cb: () => void): () => void {
  subscribers.add(cb);
  if (timer === undefined) {
    now = Date.now();
    timer = window.setInterval(() => {
      now = Date.now();
      for (const s of subscribers) s();
    }, TICK_MS);
  }
  return () => {
    subscribers.delete(cb);
    if (subscribers.size === 0 && timer !== undefined) {
      window.clearInterval(timer);
      timer = undefined;
    }
  };
}

/** Shared 30-second clock so hundreds of rows re-render together, not individually. */
export function useNow(): number {
  return useSyncExternalStore(subscribe, () => now, () => now);
}

export interface RelativeTimeProps {
  value: Date | string | number | null | undefined;
  className?: string;
}

/** "5 นาที", "เมื่อวาน"… with the full Thai date (พ.ศ.) in the title attribute. */
export function RelativeTime({ value, className }: RelativeTimeProps) {
  const nowMs = useNow();
  if (value === null || value === undefined) return <span className={className}>—</span>;
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return <span className={className}>—</span>;
  return (
    <time className={className} dateTime={date.toISOString()} title={formatThaiFullDateTime(date)}>
      {formatRelativeThai(date, new Date(nowMs))}
    </time>
  );
}
